import { call, takeEvery } from 'redux-saga/effects';
import { clearUserScopedStorage } from '@/shared/storage/client-storage';
import { SESSION_BOUNDARY_ACTIONS } from './root-reducer';

/**
 * OTURUM SINIRI TEMİZLİĞİ — kalıcı istemci depolamasının TEK temizlik noktası
 * (web ile aynı desen; QA Blok 8 P3 sınıfı).
 *
 * Kök reducer Redux'u sıfırlar, bu saga diski sıfırlar. Hangi anahtarların
 * silineceği `shared/storage/client-storage` sözleşmesinden gelir — bugün
 * kullanıcıya özel anahtar yok, ama kanca İLK anahtardan ÖNCE kurulur:
 * sonradan eklenen anahtarın temizliği unutuluyordu, sınıf tam olarak buydu.
 */
export function* storageSaga() {
  yield takeEvery([...SESSION_BOUNDARY_ACTIONS], function* clearPersistedUserData() {
    yield call(clearUserScopedStorage);
  });
}
